// extracted by mini-css-extract-plugin
export default {"patient-age":"_patient-age_35VmAs"};